import React, { Component } from "react";
import { Divider, Button, Loading } from "../Controls";
import { Link } from "react-router";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import texts from "../../assets/strings/contact.js";
import { submitFeedback } from "../../actions/actions.js";
import "./styles.less";

class ContactUsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formValid: false,
      loading: false,
      submitted: false,
      form: {
        name: {
          label: "Name",
          key: "name",
          type: "text",
          validator: value => value.length > 1
        },
        email: {
          label: "Email",
          key: "email",
          type: "email",
          validator: value => value.indexOf("@") > 0
        },
        topic: {
          label: "Subject",
          key: "topic",
          type: "select",
          value: "question",
          valid: true,
          options: [
            { value: "question", label: "Question" },
            { value: "feedback", label: "Feedback" }
          ],
          validator: value => !!value
        },
        message: {
          label: "Message",
          key: "message",
          type: "textarea",
          validator: value => value && value.length > 1
        }
      }
    };
  }

  submitForm() {
    let payload = {};
    this.setState({
      loading: true
    });

    Object.keys(this.state.form).map(
      key => (payload[key] = this.state.form[key].value)
    );
    console.log(payload);
    this.props.submitFeedback(payload);
    //setTimeout(()=>{ this.setState({ loading:false, submitted: true }) }, 1000);
  }

  onInputChange(evt, key) {
    let state = this.state;
    state.form[key]["value"] = evt.target.value;
    this.setState(state);
  }

  onInputBlur(evt, key) {
    let state = this.state;
    state.form[key]["valid"] = state.form[key].validator(evt.target.value);
    let isFormValid = true;
    Object.keys(state.form).map(
      key => (isFormValid = isFormValid ? state.form[key].valid : isFormValid)
    );
    state.formValid = isFormValid;
    this.setState(state);
  }

  renderInput(field, key) {
    return (
      <div className="inputWrapper" key={`${key}`}>
        <label
          className={`inputLabel ${
            field.valid === true
              ? "valid"
              : field.valid === false
              ? "invalid"
              : ""
          }`}
        >
          {field.label}
        </label>
        {field.type === "text" || field.type === "email" ? (
          <input
            value={field.value}
            onChange={evt => this.onInputChange(evt, key)}
            onBlur={evt => this.onInputBlur(evt, key)}
            type={field.type}
          />
        ) : null}

        {field.type === "textarea" ? (
          <textarea
            onChange={evt => this.onInputChange(evt, key)}
            onBlur={evt => this.onInputBlur(evt, key)}
          >
            {field.value}
          </textarea>
        ) : null}

        {field.type === "select" ? (
          <select
            onChange={evt => this.onInputChange(evt, key)}
            onBlur={evt => this.onInputBlur(evt, key)}
          >
            {field.options.map(opt => (
              <option key={`select-${opt.value}`} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        ) : null}
      </div>
    );
  }

  renderForm() {
    const form = this.state && this.state.form ? this.state.form : null;
    return (
      form && (
        <div>
          <p className="note">{texts.h3}</p>
          <div>
            {Object.keys(form).map(key => this.renderInput(form[key], key))}
          </div>
        </div>
      )
    );
  }

  render() {
    const { loading, feedbackSubmitted } = this.props.reducer;
    return (
      <div className="text-page contact">
        <h1>{texts.title}</h1>
        {!feedbackSubmitted ? (
          <div className="form">
            {this.renderForm()}
            <Button
              primary={true}
              large={true}
              disabled={!this.state.formValid}
              label={texts.actions.send}
              onClick={() => this.submitForm()}
            />
          </div>
        ) : (
          <div className="popup">
            <h1>{texts.popup.title}</h1>
            <h2>{texts.popup.message}</h2>
            <Button primary={true} large={true}>
              <Link to="/">{texts.actions.continue}</Link>
            </Button>
          </div>
        )}
        {loading && <Loading />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    reducer: state.appReducer
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      submitFeedback
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(ContactUsPage);



// WEBPACK FOOTER //
// ./components/Pages/ContactUs.js